import { render, staticRenderFns } from "./TypeFour.vue?vue&type=template&id=5bda320e&"
import script from "./TypeFour.vue?vue&type=script&lang=js&"
export * from "./TypeFour.vue?vue&type=script&lang=js&"
import style0 from "./TypeFour.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports